import api from '../index'

export interface AdminProfile {
  user: {
    id: number
    username: string
    nickname?: string
    avatar?: string
    email?: string
    phone?: string
    realname?: string
    position?: string
    department_id?: number
    is_super_admin?: boolean
    last_login_ip?: string
    last_login_time?: string
    login_count?: number
  }
  roles?: string[]
  is_super_admin?: boolean
}

export interface AdminProfilePayload {
  nickname: string
  realname: string
  phone: string
  email: string
  avatar: string
  gender: number
  position: string
}

export interface AdminPermissionPayload {
  permissions: string[]
}

const apiApp = {
  // 后端动态路由。
  routeList: () => api.get('/admin/system/access/permission/menus'),

  // 后台登录。
  login: (data: {
    username: string
    password: string
  }) => api.post('/admin/system/access/auth/login', data),

  // 获取当前后台用户权限编码。
  permission: () => api.get<unknown, { code: number, message: string, data: AdminPermissionPayload }>('/admin/system/access/permission/user-permissions'),

  // 当前后台用户资料。
  profile: () => api.get<unknown, { code: number, message: string, data: AdminProfile }>('/admin/system/access/auth/profile'),

  // 更新当前后台用户资料。
  profileEdit: (data: AdminProfilePayload) => api.put<unknown, { code: number, message: string, data: AdminProfile }>('/admin/system/access/auth/profile', data),

  // 后台退出登录。
  logout: () => api.post('/admin/system/access/auth/logout'),

  // 修改当前后台用户密码。
  passwordEdit: (data: {
    old_password: string
    new_password: string
    confirm_password: string
  }) => api.put('/admin/system/access/auth/password', data),

  preferences: () => api.get('app/preferences', {
    fake: true,
  }),

  preferencesEdit: (preferences: string) => api.post('app/preferences/edit', {
    preferences,
  }, {
    fake: true,
  }),

  tabbar: () => api.get('app/tabbar', {
    fake: true,
  }),

  tabbarEdit: (tabbar: string) => api.post('app/tabbar/edit', {
    tabbar,
  }, {
    fake: true,
  }),

  favorites: () => api.get('app/toolbar/favorites', {
    fake: true,
  }),

  favoritesEdit: (favorites: string) => api.post('app/toolbar/favorites/edit', {
    favorites,
  }, {
    fake: true,
  }),
}

export default apiApp
export { apiApp }
